import { Button, useTheme } from "@mui/material";
import { type LucideIcon, Plus } from "lucide-react";
import type { FC } from "react";

type Props = {
	label: string;
	onClick: () => void;
	icon?: LucideIcon;
	disabled?: boolean;
};

export const AddRowButton: FC<Props> = ({
	label,
	onClick,
	icon: Icon = Plus,
	disabled,
}) => {
	const theme = useTheme();

	return (
		<Button
			variant="addRow"
			disableRipple
			disabled={disabled}
			onClick={onClick}
		>
			<Icon size={theme.iconSize.sm} />
			{label}
		</Button>
	);
};
